// export default App;
import React, { useEffect, useState, useCallback, Fragment } from "react";
import _ from "lodash";
import "./App.css";
import {
	MAP_REFRESH_RATE,
	DATA_REFRESH_RATE,
	DEFAULT_IDLE_LIMIT_TIME,
	DEFAULT_SNACKBAR_HIDE_DURATION,
	COLORS,
	DEFAULT_CRITICAL_FUEL_CONSUMPTION_PER_MIN,
} from "@constants";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";
import { useWarning } from "./provider/WarningContext";
import { directServer, sendNotification } from "@utils";
import { DialogModal } from "@components";
// import { Provider } from 'react-redux';
import doremi from "@assets/sounds/doremi.mp3";
import dot from "@assets/sounds/dot.mp3";
import realistic_dot from "@assets/sounds/realistic_dot.mp3";
import sharp_tone from "@assets/sounds/sharp_tone.wav";
import xylophone from "@assets/sounds/xylophone.mp3";
import { selectUser } from "./@slices/userSlice";
import { useSelector } from "react-redux";
import { getSystemConfig, selectSystemConfig } from "./@slices/monitorLogSlice";
import { useDispatch } from "react-redux";

const soundConverter = (sound) => {
	switch (sound) {
		case "doremi":
			return doremi;
		case "dot":
			return dot;
		case "realistic_dot":
			return realistic_dot;
		case "sharp_tone":
			return sharp_tone;
		case "xylophone":
			return xylophone;
		default:
			return null;
	}
};

const snackbarVariant = ["default", "error", "warning", "info", "success"];

const AppNotification = () => {
	const dispatch = useDispatch();
	const user = useSelector(selectUser);
	// useEffect(() => {
	//   dispatch(getSystemConfig());
	// }, [dispatch]);
	// const systemConfig = useSelector(selectSystemConfig);
	// console.log(systemConfig);
	// const {
	//   MAP_REFRESH_RATE,
	//   DATA_REFRESH_RATE,
	//   DEFAULT_IDLE_LIMIT_TIME,
	//   DEFAULT_SNACKBAR_HIDE_DURATION,
	// } = systemConfig[0];

	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const {
		overSpeedWarning,
		overSpeedLimit,
		idleLimitWarning,
		overSpeedWarningSound,
		idleLimitWarningSound,
		mapsRefreshTimer,
		fuelTheftWarning,
		fuelTheftWarningSound,
	} = useWarning();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const timeLimit = DEFAULT_IDLE_LIMIT_TIME;
	const hideDuration = DEFAULT_SNACKBAR_HIDE_DURATION;

	const handleModalStats = () => {
		setIsDialogOpen(false);
	};

	//** Universal Monitoring Alert System */
	const fetchAlerts = useCallback(() => {
		if (user.role === "" || user.role.length === 0) return;

		directServer({
			mode: "get-allAlerts",
		}).then((res) => {
			if (res && res.length > 0) {
				res.forEach((item) => {
					const itemType = item.type.toLowerCase();
					let shouldWarn = false;
					let soundToPlay = null;

					// Based on alert type, check if warning is enabled
					if (item.type === "Truck Idling" && idleLimitWarning) {
						shouldWarn = true;
						soundToPlay = idleLimitWarningSound;
					} else if (item.type === "Truck Over Speed" && overSpeedWarning) {
						shouldWarn = true;
						soundToPlay = overSpeedWarningSound;
					} else if (item.type === "Truck Fuel Theft" && fuelTheftWarning) {
						shouldWarn = true;
						soundToPlay = fuelTheftWarningSound;
					}

					if (shouldWarn) {
						if (soundToPlay !== null) {
							triggerSound({
								sound: soundToPlay,
								message: item?.short_message,
							});
						}

						triggerSnack({
							message: item?.short_message,
							variant: snackbarVariant.includes(itemType) ? itemType : (item.type.includes("Speed") ? "warning" : "info"),
							details: item?.detail,
						});
					}
				});
			}
		});
	}, [
		user,
		idleLimitWarning,
		overSpeedWarning,
		fuelTheftWarning,
		idleLimitWarningSound,
		overSpeedWarningSound,
		fuelTheftWarningSound,
	]);

	// Initial fetch and set interval
	useEffect(() => {
		if (user.role && (idleLimitWarning || overSpeedWarning || fuelTheftWarning)) {
			fetchAlerts(); // Initial call
			const interval = setInterval(fetchAlerts, DATA_REFRESH_RATE);
			return () => clearInterval(interval);
		}
	}, [fetchAlerts, idleLimitWarning, overSpeedWarning, fuelTheftWarning]);


	const triggerSound = (props) => {
		// audioPlayer.current.play();
		// audioRef.current.play().catch((err) => {console.log(err)});
		const soundFile = props.sound ? soundConverter(props.sound) : null;
		const message = props.message ? props.message : "Notification";
		const body = props.body ? props.body : "Click to get alert";

		if (soundFile === null) return;
		const audio = new Audio(soundFile);
		audio.play().catch((err) => {
			setIsDialogOpen(true);
			sendNotification(message, {
				body: body,
			});
		});
	};

	const triggerSnack = useCallback(
		(props) => {
			enqueueSnackbar(props.message, {
				variant: props?.variant || "default",
				autoHideDuration: hideDuration,
				action: (key) => (
					<Fragment>
						<Button
							size="small"
							onClick={() => alert(`${props.details}`)}>
							Detail
						</Button>
						<Button
							size="small"
							onClick={() => closeSnackbar(key)}>
							Dismiss
						</Button>
					</Fragment>
				),
			});
		},
		[enqueueSnackbar, closeSnackbar]
	);
	// if (!isLoaded) {
	//   return <p>Loading Google Map...</p>;
	// }
	return (
		<React.Fragment>
			<DialogModal
				// title="Route History"
				message="Please interact with the page for notification sound."
				handleModalStats={handleModalStats}
				isDialogOpen={isDialogOpen}
				icon={{
					icon: "carbon:warning-alt-filled",
					color: COLORS.yellow,
				}}
			/>
		</React.Fragment>
	);
};

export default AppNotification;
